module.exports = __webpack_public_path__ + "static/img/logo_yuhong.671d1e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_yuhong.png
// module id = 8tb3
// module chunks = 1